<template>
  <div class="pi-afilters" role="group" aria-label="Filtros das áreas do produto">
    <filter-select class="pi-afilters__field" label="Porte (funcionários)" :value="state.sizeBand" :options="sizeBandOptions"
                   @input="set('sizeBand', $event)">
      <pi-definition-tooltip slot="info" class="pi-afilters__info" info-key="areas.filter.sizeBand" label="Porte (funcionários)"/>
    </filter-select>
    <div class="pi-afilters__field">
      <span class="pi-afilters__label">
        <label :for="ids.segment" class="pi-afilters__text">Perfil da empresa</label>
        <pi-definition-tooltip class="pi-afilters__info" info-key="areas.filter.segment" label="Perfil da empresa"/>
      </span>
      <input :id="ids.segment" type="text" class="form-control pi-input pi-afilters__segment" maxlength="60" placeholder="A, B, C, D ou E"
             :value="state.segment" @change="set('segment', $event.target.value)" @keydown.enter.prevent="$event.target.blur()">
    </div>
    <filter-select class="pi-afilters__field" label="Jornada" :value="state.journey" :options="journeyOptions" all-label="Todas"
                   @input="set('journey', $event)">
      <pi-definition-tooltip slot="info" class="pi-afilters__info" info-key="areas.filter.journey" label="Jornada"/>
    </filter-select>
    <filter-select class="pi-afilters__field" label="Trial" :value="state.trial" :options="trialOptions" :all-label="trialAllLabel"
                   @input="set('trial', $event)">
      <pi-definition-tooltip slot="info" class="pi-afilters__info" info-key="areas.filter.trial" label="Trial"/>
    </filter-select>
    <a v-if="active" href="#" class="pi-afilters__clear" @click.prevent="clear">Limpar filtros</a>
    <p v-if="ignored.length" class="pi-afilters__ignored">Não se aplica a esta visão: {{ ignored.join(' · ') }}</p>
  </div>
</template>

<script>
import filterSelect from "../default/filterSelect.vue";
import piDefinitionTooltip from "./piDefinitionTooltip.vue";
import { JOURNEY_OPTIONS, SIZE_BAND_FILTER_OPTIONS } from "./piQuery.js";
import { AREA_FILTER_DEFAULTS, AREA_TRIAL_ALL_LABEL, AREA_TRIAL_OPTIONS, cleanAreaFilters, hasAreaFilters } from "./piAreasModel.js";

let sequence = 0;

export default {
  name: "pi-area-filters",
  components: { filterSelect, piDefinitionTooltip },
  props: {
    value: { type: Object, default: () => Object.assign({}, AREA_FILTER_DEFAULTS) },
    ignored: { type: Array, default: () => [] },
  },
  data() {
    sequence += 1;
    return {
      ids: { segment: "pi-afilters-" + sequence + "-segment" },
      sizeBandOptions: SIZE_BAND_FILTER_OPTIONS,
      journeyOptions: JOURNEY_OPTIONS,
      trialOptions: AREA_TRIAL_OPTIONS,
      trialAllLabel: AREA_TRIAL_ALL_LABEL,
    };
  },
  computed: {
    state() {
      return cleanAreaFilters(this.value);
    },
    active() {
      return hasAreaFilters(this.state);
    },
  },
  methods: {
    set(key, raw) {
      const next = Object.assign({}, this.state);
      next[key] = raw === null || raw === undefined ? "" : String(raw);
      this.$emit("input", cleanAreaFilters(next));
    },
    clear() {
      this.$emit("input", Object.assign({}, AREA_FILTER_DEFAULTS));
    },
  },
};
</script>

<style src="./pi.css"></style>

<style scoped>
.pi-afilters {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px 20px;
  margin-bottom: 18px;
  padding: 12px 14px;
  border: 1px solid #e6e7eb;
  border-radius: 6px;
  background: #fafbfc;
}

.pi-afilters__field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 170px;
}

.pi-afilters__label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.pi-afilters__text {
  margin: 0;
  font-size: 12px;
  font-weight: 400;
  color: #4e5560;
}

.pi-afilters__info {
  margin-left: 4px;
  vertical-align: middle;
}

.pi-afilters__segment {
  width: 200px;
}

.pi-afilters__clear {
  padding-bottom: 8px;
  font-size: 12px;
  color: #1b59f8;
}

.pi-afilters__ignored {
  flex: 1 1 100%;
  margin: 0;
  font-size: 11px;
  color: #7a4f00;
}

.pi-afilters__clear:hover,
.pi-afilters__clear:focus {
  color: #1b59f8;
  text-decoration: underline;
}

@media (max-width: 767px) {
  .pi-afilters {
    flex-direction: column;
    align-items: stretch;
  }

  .pi-afilters__field,
  .pi-afilters__segment {
    width: 100%;
    min-width: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/pi/piAreaFilters.vue